<div class="d-flex flex-column">
  <div class="d-flex flex-row header-form" style="background-color: #f37024;">
    <div class="col-12  col-lg-8 offset-lg-2 py-5">
      <form [formGroup]="SearchForm" autocomplete="off" (ngSubmit)="SearchData()"
        class="form-content d-flex flex-fill flex-column">
        <span class="tracking-header text-md-left text-center">
          {{'p.track.title'|translate}}
        </span>
        <div class="d-flex flex-column flex-sm-row ">
          <div class="input-highlight-panel d-flex flex-row flex-fill align-items-center mb-3 mx-sm-0 mx-3 ">
            <textarea #textarea_tracking [hidden]="!FocusInput" (blur)="SwtichFocus(false);" (focus)="autogrow()"
              (keydown.enter)="SearchData()" class="form-control textarea-scroll ke-placeholder-color" style="font: normal var(--font-tracking-input) / 16px var(--font);" PreventKeys
              formControlName="tracking" 
              placeholder="{{'p.track.enter.tracking-number'|translate}}" #ta (keyup)="autogrow()" (paste)="autoCommaTextSeatch($event)"></textarea>

            <input #input_tracking [hidden]="FocusInput" (focus)="SwtichFocus(true); " type="text"
              class="form-control tracking-input ke-placeholder-color" PreventKeys (keydown.enter)="SearchData()"
              placeholder="{{'p.track.enter.tracking-number'|translate}}" [value]="SearchForm.get('tracking').value">
            <div class="input-group-append" style="align-items: center;color:gray"
              *ngIf="SearchForm.controls['tracking'].value && SearchForm.controls['tracking'].value.length>0">
              <mat-icon style="cursor: pointer;" (click)="SearchForm.controls['tracking'].setValue('')">cancel
              </mat-icon>
            </div>
          </div>
          <div class="justify-content-center d-flex flex-row ml-3">
            <button class="ke-btn-search" type="submit">{{'g.track'|translate}}</button>
          </div>
        </div>
      </form>
    </div>
  </div>

</div>
